/** @jsxImportSource @emotion/react */
import { useEffect, useRef } from "react";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";
import { tituloBase, Titulo } from "../../shared";
import useConPenta from "../importaciones/useConPenta";
import ImportacionesRevision from "./ImportacionesRevision";

/**
 * Importaciones de Penta-Transaction pendientes de revisión. El menú solo la
 * ofrece si el organismo tiene la integración; si igual se entra por la URL,
 * se avisa en vez de mostrar una tabla que nunca va a tener datos.
 */
export default function Importaciones() {
  const conPenta = useConPenta();
  const toast = useRef(null);

  useEffect(() => {
    document.title = "Importaciones";
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Titulo>Importaciones (Penta-Transaction)</Titulo>

      {conPenta === null && (
        <Skeleton width="100%" height="10rem" borderRadius="6px" />
      )}
      {conPenta === false && (
        <Message
          severity="info"
          css={{ width: "100%", justifyContent: "flex-start" }}
          text="El organismo no tiene configurada la integración con Penta-Transaction."
        />
      )}
      {conPenta && (
        <Card>
          <ImportacionesRevision toast={toast} />
        </Card>
      )}
    </>
  );
}
